let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("g1Ukm"), load("diXnR"), load("6u1HZ")]).then(() => parcelRequire('el3Ev'));